import { createSlice } from '@reduxjs/toolkit';
import dayjs, { Dayjs } from "dayjs";
import { GlobalState } from '../types/types';
import { getHalfOffset, getQuarterOffset } from '../utils/utils';

const initialState: GlobalState = {
    path: '',
    companies: [],
    selectedCompanyId: 1,
    updateDate: dayjs(),
    period: '1',
    dates: [dayjs().subtract(1, "month").startOf("month"), dayjs().subtract(1, "month").endOf("month")],
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setPath: (state, action) => {
        state.path = action.payload;
    },
    setCompanyId: (state, action) => {
      state.selectedCompanyId = action.payload;
    },
    setCompanies: (state, action) => {
        const companies = action.payload;

        state.selectedCompanyId = +companies[0].id;
        state.updateDate = dayjs();
        state.period = '1';
        state.dates = [dayjs().subtract(1, "month").startOf("month"), dayjs().subtract(1, "month").endOf("month")];
        state.companies = action.payload;
    },
    setCustomDates: (state, action) => {
      const dates = action.payload;
      state.period = '6';
      state.dates = [dates[0]!.startOf("month"), dates[1]!.endOf("month")];
    },
    setPeriod: (state, action) => {
      const period = action.payload;

      var _dates: [Dayjs, Dayjs];
      if (period === '1') {
        _dates = [dayjs().subtract(1, "month").startOf("month"), dayjs().subtract(1, "month").endOf("month")];
      } else if (period === '2') {
        // Za poslední kvartál
        const number = getQuarterOffset();
        _dates = [dayjs().subtract((3 + number), "month").startOf("month"), dayjs().subtract(number, "month").endOf("month")];
      } else if (period === '3') {
        // Za poslední půlrok
        const number = getHalfOffset();
        _dates = [dayjs().subtract((5 + number), "month").startOf("month"), dayjs().subtract(number, "month").endOf("month")];
      } else if (period === '4') {
        // Za poslední rok
        _dates = [dayjs().subtract(1, "year").startOf("year"), dayjs().subtract(1, "year").endOf("year")];
      } else {
        _dates = [dayjs().startOf("month"), dayjs().endOf("month")];
      }

      state.period = period;
      state.dates = _dates;
    },
    updateDate: (state) => {
      state.updateDate = dayjs();
    }
  }
});

export const { setCompanyId, setCompanies, setPath, setCustomDates, setPeriod, updateDate } = globalSlice.actions;
export default globalSlice.reducer;